module.exports = __webpack_public_path__ + "media/images/cover/kitchen-beafdb0e3f7ecf04044785f2fbed35fe.jpeg";